import { motion } from "framer-motion";
import { useRef, useEffect } from "react";
import styles from './homei.module.css';

// const scrollToSection = (id) => {
//   const el = document.getElementById(id);
//   if (el) {
//     el.scrollIntoView({ behavior: "smooth" });
//   }
// };

// function WhyChooseCard({ img, title, desc, index }) {
//   return (
//     <div className={styles.card}>
//       <img src={img} alt={title} className={styles.cardImage} />
//       <div className={styles.cardContent}>
//         <h3 className={`${styles.textLarge} font-bold text-purple-800 mb-2 pb-0 leading-tight`}>
//           {String(index + 1).padStart(2, '0')} <span className="text-gray-900 font-semibold ml-2">{title}</span>
//         </h3>
//         <p className="text-gray-700 text-lg mt-0 pt-0">
//           {desc}
//         </p>
//       </div>
//     </div>
//   );
// }

export default function HomeInteriorPage() {
  const whyChooseRef = useRef(null);
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (whyChooseRef.current) {
        const container = whyChooseRef.current;
        const cardWidth = container.firstChild?.offsetWidth || 0;
        if (cardWidth) {
          if (container.scrollLeft + container.offsetWidth >= container.scrollWidth - 5) {
            container.scrollTo({ left: 0, behavior: "smooth" });
          } else {
            container.scrollBy({ left: cardWidth, behavior: "smooth" });
          }
        }
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
 
    
      
      <div className={styles.headerSpacer}>
        {/* Hero Section */}
        <section id="home" className={styles.hero} style={{backgroundImage: 'url("/hero-bg.jpg")'}}>
          <div className={styles.heroOverlay}></div>
          <div className={styles.heroContent}>
            <motion.h1
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg mb-4"
            >
              Design Beyond Walls — Elevate Your Home Interiors with Property Plateau
            </motion.h1>
          </div>
        </section>

        {/* Features Section */}
        <section className={styles.featuresSection}>
          <div className={styles.featuresText}>
            <span className={styles.uppercaseLabel}>Features</span>
            <h3 className="text-3xl md:text-5xl font-semibold text-blue-600 mb-6 leading-tight">Style. Function. Comfort. All in Perfect Harmony</h3>
            <p className="text-black-700 text-lg mb-8">At Property Plateau Realty, we believe your home should reflect who you are — stylish, serene, and smartly designed. Our turnkey home interior design services blend beauty and functionality to craft spaces that elevate everyday living.</p>
          </div>
          <div className={styles.featuresDivider}></div>
          <div className={styles.featuresImage}>
            <img src="/features.jpg" alt="Features" className="w-full h-48 md:h-72 object-cover rounded-2xl" />
          </div>
        </section>

      

      {/* Why Choose Us Section */}
<section className={styles.whyChooseSection} style={{backgroundImage: 'url("/why-choose-bg.jpg")'}}>
  <div className={styles.whyChooseHeader}>
    <h2 className={styles.sectionTitle}>Why Choose Property Plateau for Home Interiors?</h2>
    <hr className="border-blue-200 mb-10" />
  </div>
  <div className={styles.whyChooseContent}>
    {[  
      {
        title: "Custom Designs for Every Budget",
        desc: "From luxury interiors to budget-friendly makeovers, our team delivers creative solutions without compromising on quality or comfort."
      },
      {
        title: "End-to-End Turnkey Execution",
        desc: "We handle everything — from space planning and 3D visualizations to furniture, lighting, false ceiling, modular kitchen, and final styling. Just sit back and relax!"
      },
      {
        title: "Expert Team: Skilled Interior Architects & Designers",
        desc: "Our design team includes certified professionals, decorators, and Vastu-aligned planners to ensure both aesthetic value and positive energy."
      },
      {
        title: "Timely Delivery, Hassle-Free Experience",
        desc: "Your time matters. We ensure transparent timelines, on-site coordination, and a smooth process from concept to completion."
      },
      {
        title: "Smart Homes & Sustainable Solutions",
        desc: "We offer modern interiors with smart technology integration, eco-friendly materials, and space-maximizing innovations."
      }
    ].map((item, index) => (
      <div key={index} className={styles.whyChooseItem}>
        <div className="w-full">
          <h3 className="text-2xl font-semibold text-gray-800 mb-3">{item.title}</h3>
          <p className="text-gray-700 text-lg">
            {item.desc}
          </p>
        </div>
      </div>
    ))}
  </div>
</section>
        {/* About Section */}
        <section id="about" className={styles.aboutSection} style={{backgroundImage: 'url("/vision.jpeg")'}}>
          <div className={styles.aboutOverlay}></div>
          <div className={styles.aboutContent}>
            <h2 className="text-3xl font-bold text-blue-600 mb-4">Your Vision, Our Execution</h2>
            <p className="max-w-2xl mx-auto font-semibold text-lg text-black-700">Whether you're moving into a new flat, renovating your villa, or refreshing a single room — we bring your vision to life with precision, creativity, and care.</p>
          </div>
        </section>

    {/* Areas We Serve Section */}
<section className={styles.areasSection}>
  <h2 className={styles.areasTitle}>Areas We Serve</h2>
  <div className={styles.areasContainer}>
    <div className={styles.areasGrid}>
      {[
        { img: "/mumbai.jpg", caption: "Mumbai" },
        { img: "/pune.jpg", caption: "Pune" },
        { img: "/goa.jpg", caption: "Goa" },
        { img: "/bangalore.jpg", caption: "Bangalore" },
        { img: "/hydrabad.jpg", caption: "Hyderabad" },
        { img: "/delhi.jpg", caption: "Delhi-NCR" }
      ].map((area, idx) => (
        <div key={idx} className={styles.areaCard}>
          <div className={styles.areaImageContainer}>
            <img 
              src={area.img} 
              alt={area.caption} 
              className={styles.areaImage}
              loading="lazy"
            />
          </div>
          <div className={styles.areaCaption}>{area.caption}</div>
        </div>
      ))}
    </div>
  </div>
</section>

        {/* Testimonials Section */}
        <section className={styles.testimonialsSection}>
          <h2 className={styles.sectionTitle}>What Our Clients Say</h2>
          <div className={styles.testimonialsGrid}>
            {[
              {
                name: "Sneha R.",
                location: "Magarpatta, Pune",
                review: "My 2BHK in Pune looks like a luxury suite now. Everything from color themes to lighting was perfectly executed.",
                img:""
              },
              {
                name: "Rohit M.",
                location: "North Goa",
                review: "Property Plateau handled our villa interiors in Goa—elegant, functional, and within budget. Impressive work!",
                img:""
              }
            ].map((t, i) => (
              <motion.div
                key={i}
                whileHover={{ scale: 1.03 }}
                className={styles.testimonialCard}
              >
                <p className="text-black-800 text-lg mb-6">"{t.review}"</p>
                <div className="mt-4">
                  <div className="font-semibold text-black-900">{t.name}</div>
                  <div className="text-black-500 text-sm">{t.location}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Contact Section
        <section className={styles.contactSection}>
          <div className={styles.contactContainer}>
            <div className="flex-1 mb-10 md:mb-0 md:pr-8">
              <h2 className="text-3xl md:text-5xl font-semibold text-blue-600 mb-6 leading-tight">Let's Build Your Dream Home, Together</h2>
              <p className="text-3xl md:text-4x1 font-semibold text-black mb-8">Ready to design interiors that feel like home and look like art?</p>
              <div className="text-3xl md:text-4x1 font-semibold text-black mb-8">We're just one consultation away from transforming your space.</div>
            </div>
            <div className={styles.contactForm}>
              <form className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-1">
                    <label className="block text-gray-700 mb-2">First name *</label>
                    <input type="text" className={styles.formInput} required />
                  </div>
                  <div className="flex-1">
                    <label className="block text-gray-700 mb-2">Last name *</label>
                    <input type="text" className={styles.formInput} required />
                  </div>
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Email *</label>
                  <input type="email" className={styles.formInput} required />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Subject</label>
                  <input type="text" className={styles.formInput} />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Message</label>
                  <textarea className={styles.formInput} rows="4"></textarea>
                </div>
                <button type="submit" className={styles.formButton}>Submit</button>
              </form>
            </div>
          </div>
        </section> */}

      
      </div>
    
  );
}